import { SET_EVENT_DATA,SET_EVENT_HALL,SET_LIVE_PRESENTATION,SET_PANEL_DISCUSSION ,SET_ON_DEMAND, SET_ROUND_TABLE,SET_SPEAKERS} from "../../ActionTypes/Event/eventActionTypes";

export const setEventData = (value: any) => ({
  type: SET_EVENT_DATA,
  payload: value,
});

export const setEventHall = (value: any) => ({
  type    : SET_EVENT_HALL,
  payload : value
});

export const setLivePresentation=(value:any)=>({
  type: SET_LIVE_PRESENTATION,
  payload: value
})

export const setPanelDiscussion=(value:any)=>({
  type: SET_PANEL_DISCUSSION,
  payload: value
})

export const setOnDemand=(value:any)=>({
  type: SET_ON_DEMAND,
  payload: value
})

export const setRoundTable=(value:any)=>({
  type: SET_ROUND_TABLE,
  payload: value
})

export const setSpeakers = (speakers:any) => ({
  type: SET_SPEAKERS,
  payload: speakers,
});

export const setSpeakersCount = (value:any) => ({
  type: "SET_SPEAKERS_COUNT",
  payload: value,
});

export const setExhibitorCount = (value:any) => ({
  type: "SET_EXHIBITOR_COUNT",
  payload: value,
});

export const setPartipantCount = (value:any) => ({
  type: "SET_PARTICIPANT_COUNT",
  payload: value,
});


